(() => {
  if (window.PlushSections) return;
  const factories = new Map(), loads = new Map(), instances = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function lifecycle(scope) {
    const listeners = [], timers = new Set(), intervals = new Set(), frames = new Set();
    let alive = true;
    const visible = () => {
      if (!alive || document.hidden) return false;
      const r = scope.getBoundingClientRect();
      return r.bottom > 0 && r.top < innerHeight && r.width > 0;
    };
    return {
      listen(target, type, fn, opts) {
        if (type === 'DOMContentLoaded' && document.readyState !== 'loading') { fn.call(document, new Event(type)); return; }
        target.addEventListener(type, fn, opts);
        listeners.push([target, type, fn, opts]);
      },
      timeout(fn, ms, ...args) { const id = setTimeout(() => { timers.delete(id); if (alive) fn(...args); }, ms); timers.add(id); return id; },
      interval(fn, ms, ...args) { const id = setInterval(() => { if (visible() && !reduced.matches && !window.Shopify?.designMode) fn(...args); }, ms); intervals.add(id); return id; },
      clearTimeout(id) { clearTimeout(id); timers.delete(id); },
      clearInterval(id) { clearInterval(id); intervals.delete(id); },
      frame(fn) { const id = requestAnimationFrame(t => { frames.delete(id); if (alive) fn(t); }); frames.add(id); return id; },
      cancelFrame(id) { cancelAnimationFrame(id); frames.delete(id); },
      destroy() {
        alive = false;
        for (const [target, type, fn, opts] of listeners) target.removeEventListener(type, fn, opts);
        timers.forEach(clearTimeout); intervals.forEach(clearInterval); frames.forEach(cancelAnimationFrame);
      }
    };
  }
  function load(key, url) {
    if (factories.has(key)) return Promise.resolve();
    if (!loads.has(url)) loads.set(url, new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url; script.async = true;
      script.onload = resolve;
      script.onerror = () => { loads.delete(url); reject(new Error('Section controls could not load')); };
      document.head.append(script);
    }));
    return loads.get(url);
  }
  async function mount(node) {
    if (instances.has(node)) return;
    const scope = node.closest('.shopify-section') || node.parentElement;
    const life = lifecycle(scope); instances.set(node, life);
    try {
      await load(node.dataset.plushInit, node.dataset.plushSrc);
      if (instances.get(node) !== life) return;
      if (!node.isConnected) { life.destroy(); instances.delete(node); return; }
      factories.get(node.dataset.plushInit)?.(scope, JSON.parse(node.textContent), life);
    } catch (error) { life.destroy(); instances.delete(node); console.warn(error.message); }
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) {
      observer.unobserve(entry.target);
      entry.target.querySelectorAll('[data-plush-init]').forEach(mount);
    }
  }, { rootMargin: '400px' }) : null;
  function scan(root = document) {
    root.querySelectorAll('[data-plush-init]').forEach(node => {
      const scope = node.closest('.shopify-section') || node.parentElement;
      if (window.Shopify?.designMode || !observer || scope.getBoundingClientRect().top < innerHeight + 400) mount(node);
      else observer.observe(scope);
    });
  }
  window.PlushSections = { define: (key, fn) => factories.set(key, fn) };
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    observer?.unobserve(event.target);
    for (const [node, life] of instances) if (event.target.contains(node)) { life.destroy(); instances.delete(node); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
})();
